export default "__VITE_ASSET__Dea3tDbc__"